import slice from "./footfallNewSlice";

export default slice.reducer;
